<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderNumber" label="关联工单号">
              {{ formData.orderNumber || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="userId" label="关联客户">
              {{ formData.userName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="userId" label="出入库类型">
              {{ ygType2Map.get(formData.ygType) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号">
              {{ formData.plateNumber }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleGph" label="挂车号">
              {{ formData.vehicleGph || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="司机姓名">
              {{ formData.driverName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="司机手机号">
              {{ formData.driverPhone || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverId" label="司机身份证">
              {{ formData.driverId || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleType" label="车辆类型">
              {{ vehicleTypeMap.get(formData.vehicleType) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateStart" label="可预约日期(开始)">
              {{ formData.vehicleDateStart || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateEnd" label="可预约日期(结束)">
              {{ formData.vehicleDateEnd || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plannedNum" label="计划装货数量">
              {{ formData.plannedNum || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plannedDate" label="计划入场日期">
              {{ formData.plannedDate || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="timeslotId" label="计划入场时间段">
              {{ formData.timeslotVal || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="reservationStatus" label="预约状态">
              {{ reservationStatusMap.get(formData.reservationStatus) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="arrivalStatus" label="到达状态">
              {{ arrivalStatusMap.get(formData.arrivalStatus) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isMeal" label="司机报餐">
              {{ isMealFormatMap.get(formData.isMeal) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="arrivalTime" label="签到时间">
              {{ formData.arrivalTime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="endTime" label="完成时间">
              {{ formData.endTime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly :has-add="hasAddFile" v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="specList" label="品种规格">
              <el-table size="mini" stripe border :data="formData.specList">
                <el-table-column prop="specName" label="品种规格"></el-table-column>
                <el-table-column prop="planQuantity" label="计划装货数量"></el-table-column>
                <el-table-column prop="pickupQuantity" label="实际装货数量"></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="物流记录">
            <el-table size="mini" stripe border :data="recordList">
              <el-table-column show-overflow-tooltip min-width="180" label="操作人" prop="operator"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作类型" prop="">
                <template v-slot="{ row }">
                  {{ operationTypeMap.get(row.operationType) || '--' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作IP" prop="operationIp"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作终端"
                prop="operationTerminal"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作系统"
                prop="operationSystem"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作时间"
                prop="operationTime"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="计划入场日期"
                prop="plannedDate"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="约饭" prop="">
                <template v-slot="{ row }">
                  {{ isMealFormatMap.get(row.isMeal) || '--' }}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button type="primary" v-if="hasBack && formData.reservationStatus === '6'" @click="submitBack">退回</el-button>
              <!-- <el-button type="primary" v-if="hasEdit" @click="$router.push('/entryplan/edit?planId=' + formData.planId)">编辑</el-button> -->
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { vehicleType, reservationStatus, arrivalStatus, isMealFormat, operationType, ygType2 } from '@/utils/dict'
export default {
  name: 'EntryPlanDetail',
  data() {
    return {
      recordList: [],
      ygType2Map: ygType2,
      vehicleTypeMap: vehicleType,
      reservationStatusMap: reservationStatus,
      operationTypeMap: operationType,
      arrivalStatusMap: arrivalStatus,
      isMealFormatMap: isMealFormat,
      formData: {
        orderNumber: '', // 关联工单号
        ygType: '',
        userId: '', // 关联客户
        userName: '', // 客户名称
        plateNumber: '', // 车牌号
        vehicleGph: '', // 挂车号
        driverName: '', // 司机姓名
        driverPhone: '', // 司机手机号
        driverId: '', // 司机身份证
        vehicleType: '', // 车辆类型1大车2小车
        plannedDate: '', // 计划入场日期
        timeslotId: '', // 计划入场时间段id
        timeslotVal: '', // 计划入场时间段
        reservationStatus: '', // 预约状态1待预约2已预约
        arrivalStatus: '', // 到达状态1等待中2按时到达3超时到达4未到达5无预约进场
        arrivalTime: '' // 签到时间
      }
    }
  },
  created() {
    console.log('buttonList', this.buttonList)
    if (this.planId) {
      this.loadData()
    }
  },
  computed: {
    planId() {
      return this.$route.query.planId
    },
    buttonList() {
      return this.$store.getters.getMenuByCode('WLJH')
    },
    hasBack() {
      return this.buttonList.includes('back')
    },
    hasAddFile() {
      return this.buttonList.includes('addFile')
    }
  },
  methods: {
    submitBack() {
      this.$confirm('确认退回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.bakeWlVehiclePlan, {
          planId: this.planId
        }).then(res => {
          this.loadData()
        })
      })
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanByPlanId, { planId: this.planId }).then(res => {
        this.formData = res
        this.recordList = res.recordList || []
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-direction: column;
}
</style>
